<ng-select
  [ngModel]="value"
  [multiple]="true"
  [closeOnSelect]="false"
  [compareWith]="compareFn"
  (ngModelChange)="onSelectionChange($event)"
>
  <ng-option *ngFor="let option of options" [value]="option">{{
    option.display
  }}</ng-option>
</ng-select>
